import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'search-types',
    template: `<div class="result-types btn-group btn-group-sm glyph-group-sm">
                    <a class="btn"
                        *ngFor="let choice of choices"
                        (click)="toggleSection(choice.section)"
                        [ngClass]="{ 'active btn-primary': choice.selected }">
                        <gf-glyph [class]="choice.glyph"></gf-glyph>
                        <span>{{choice.title}}</span>
                    </a>
                </div>`
})
export class SearchTypesComponent implements OnInit, OnChanges {

    @Input() sections: string[] = [];
    @Output() sectionsChange = new EventEmitter<string[]>();

    choices = [
        {
            section: 'project',
            glyph: 'project',
            selected: false,
            title: 'Projects'
        },
        {
            section: 'user',
            glyph: 'user',
            selected: false,
            title: 'People'
        },
        {
            section: 'trackeritem',
            glyph: 'ticket',
            selected: false,
            title: 'Tracker Items'
        },
        {
            section: 'scm',
            glyph: 'code',
            selected: false,
            title: 'Code'
        },
        {
            section: 'scmcommit',
            glyph: 'commit',
            selected: false,
            title: 'Commits'
        },
        {
            section: 'wiki',
            glyph: 'wiki',
            selected: false,
            title: 'Wiki Pages'
        },
        {
            section: 'docman',
            glyph: 'document',
            selected: false,
            title: 'Docman Files'
        },
        {
            section: 'forum',
            glyph: 'chat',
            selected: false,
            title: 'Discussion Messages'
        }
    ];

    constructor() { }

    ngOnInit(): void {
        this.updateChoices();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.sections) {
            this.updateChoices();
        }
    }

    updateChoices = (): void => {
        const currentSections = this.sections || [];
        this.choices = this.choices.map((item) => ({
            ...item,
            selected: currentSections.includes(item.section)
        }));
    }

    toggleSection = (section: string): void => {
        const currentSections = this.sections ? [...this.sections] : [];
        let include: string[];

        if (currentSections.includes(section)) {
            include = currentSections.filter(s => s !== section);
        } else {
            include = [...currentSections, section];
        }

        // Filter out empty strings
        const filteredSections = include.filter(s => s !== '');

        this.sections = filteredSections;
        this.updateChoices();

        // Emit notification
        this.sectionsChange.emit(filteredSections);
    };
}